export default __webpack_public_path__ + "static/media/login.95c7c6b1.jpg";